
import loadable from '@modern-js/runtime/loadable';

const __modern_js_src_pages_index_tsx = loadable(() => import('@_modern_js_src/pages/index.tsx'));

const __modern_js_src_pages_bbc_tsx = loadable(() => import('@_modern_js_src/pages/bbc.tsx'));

const __modern_js_src_pages_bsc_tsx = loadable(() => import('@_modern_js_src/pages/bsc.tsx'));

const __modern_js_src_pages_eth_tsx = loadable(() => import('@_modern_js_src/pages/eth.tsx'));


export const routes = [
  {
    "path": "/",
    "_component": "@_modern_js_src/pages/index.tsx",
    "component": __modern_js_src_pages_index_tsx,
    "exact": true
  },
  {
    "path": "/bbc",
    "_component": "@_modern_js_src/pages/bbc.tsx",
    "component": __modern_js_src_pages_bbc_tsx,
    "exact": true
  },
  {
    "path": "/bsc",
    "_component": "@_modern_js_src/pages/bsc.tsx",
    "component": __modern_js_src_pages_bsc_tsx,
    "exact": true
  },
  {
    "path": "/eth",
    "_component": "@_modern_js_src/pages/eth.tsx",
    "component": __modern_js_src_pages_eth_tsx,
    "exact": true
  }
]
